/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Alpha_Complete_ToastInputs */

const en_video_export_alpha_complete_toast = /** @type {(inputs: Video_Export_Alpha_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alpha video export complete!`)
};

const fr_video_export_alpha_complete_toast = /** @type {(inputs: Video_Export_Alpha_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation video alpha terminee !`)
};

const de_video_export_alpha_complete_toast = /** @type {(inputs: Video_Export_Alpha_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alpha-Videoexport abgeschlossen!`)
};

const it_video_export_alpha_complete_toast = /** @type {(inputs: Video_Export_Alpha_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione video Alpha completata!`)
};

const ru_video_export_alpha_complete_toast = /** @type {(inputs: Video_Export_Alpha_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт альфа-канала видео завершен!`)
};

const es_video_export_alpha_complete_toast = /** @type {(inputs: Video_Export_Alpha_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Exportación de video alfa completada!`)
};

const zh_cn2_video_export_alpha_complete_toast = /** @type {(inputs: Video_Export_Alpha_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alpha 视频导出完成！`)
};

const ja_video_export_alpha_complete_toast = /** @type {(inputs: Video_Export_Alpha_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アルファビデオのエクスポートが完了しました。`)
};

const hi_video_export_alpha_complete_toast = /** @type {(inputs: Video_Export_Alpha_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अल्फा वीडियो का निर्यात सफलतापूर्वक पूरा हुआ!`)
};

const pt_pt2_video_export_alpha_complete_toast = /** @type {(inputs: Video_Export_Alpha_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação do vídeo alfa concluída!`)
};

/**
* | output |
* | --- |
* | "Alpha video export complete!" |
*
* @param {Video_Export_Alpha_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_alpha_complete_toast = /** @type {((inputs?: Video_Export_Alpha_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Alpha_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_alpha_complete_toast(inputs)
	if (locale === "de") return de_video_export_alpha_complete_toast(inputs)
	if (locale === "it") return it_video_export_alpha_complete_toast(inputs)
	if (locale === "ru") return ru_video_export_alpha_complete_toast(inputs)
	if (locale === "es") return es_video_export_alpha_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_alpha_complete_toast(inputs)
	if (locale === "ja") return ja_video_export_alpha_complete_toast(inputs)
	if (locale === "hi") return hi_video_export_alpha_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_alpha_complete_toast(inputs)
	return en_video_export_alpha_complete_toast(inputs)
});